jQuery(async function() {
    await timeout(250);
    packageProtectionModule();
    //await timeout(1500);
    setInterval(setPackageProtectionBlockText, 1000);
});

// window.onload = async function() {
//     await timeout(250);
//     packageProtectionModule();
//     //await timeout(1500);
//     setInterval(setPackageProtectionBlockText, 1000);
// };

const timeout = (ms) => {
    return new Promise(resolve => setTimeout(resolve, ms));
}

const togglePackageProtection = async() => {
    let packageProtectionAcceptedCookie = sessionStorage.getItem(`package-protection-block`);
    packageProtectionAcceptedCookie = (packageProtectionAcceptedCookie.toLowerCase() === 'true');

    if (packageProtectionAcceptedCookie) {
        removePackageProtectionCookie(null, true);
    } else {
        setPackageProtectionCookie();
    }
    await packageProtectionModule();
}

const readPackageProtectionCookie = () => {
    let packageProtectionAcceptedCookie = sessionStorage.getItem(`package-protection-block`);
    if (packageProtectionAcceptedCookie !== null) {
        packageProtectionAcceptedCookie = (packageProtectionAcceptedCookie.toLowerCase() === 'true');
    }
    return packageProtectionAcceptedCookie;
}

const packageProtectionModule = async() => {
    const packageProtectionHandle = 'svp-package-protection';
    const productURL = `/products/${packageProtectionHandle}.json`;
    const ineligibleItemsList = [6124913524890];

    let packageProtectionAcceptedCookie = readPackageProtectionCookie();
    if (packageProtectionAcceptedCookie === null) {
        setPackageProtectionCookie();
    }

    let packageProtectionJSON = await getProductData(productURL);

    let cartJSON = await getCart();
    let storePickupInCart = await orderContainsStorePickupItem(cartJSON);
    if (storePickupInCart) {
        removePackageProtectionCookie(null, true);
    }

    let packageProtectionProductsInCart = isPackageProtectionInCart(cartJSON, packageProtectionJSON);
    let ineligibleProductsInCartJSON = ineligibleItemsInCart(cartJSON, ineligibleItemsList);
    let variantToBeAdded = calculateCoverageVariantNeeded(cartJSON, packageProtectionJSON, packageProtectionProductsInCart, ineligibleProductsInCartJSON);

    packageProtectionAcceptedCookie = readPackageProtectionCookie();;
    if (packageProtectionAcceptedCookie && variantToBeAdded !== null) {
        if ((storePickupInCart === true) && (packageProtectionProductsInCart.length !== 0)) {
            await removeAllVariants(packageProtectionProductsInCart);
        } else if (packageProtectionProductsInCart.length === 0) {
            await addCoverage(variantToBeAdded.id);
        } else if (packageProtectionProductsInCart.length === 1) {
            // check if the correct variant and quantity is present
            if ((packageProtectionProductsInCart[0].id !== variantToBeAdded.id) || (packageProtectionProductsInCart[0].quantity > 1)) {
                await removeAllVariants(packageProtectionProductsInCart);
                await addCoverage(variantToBeAdded.id);
            }
        } else {
            // if there are multiple products in the cart
            await removeAllVariants(packageProtectionProductsInCart);
            await addCoverage(variantToBeAdded.id);
        }
        await Shopify.theme.ajaxCart.init();
    } else if (packageProtectionAcceptedCookie === false || variantToBeAdded === null) {
        await removeAllVariants(packageProtectionProductsInCart);
        await Shopify.theme.ajaxCart.init();
    }
}

const calculateCoverageVariantNeeded = (cartJSON, packageProtectionJSON, packageProtectionProductsInCart, ineligibleProductsInCartJSON) => {
    let totalProductVariantsPrice = 0;
    const variantPricingDifference = 0.50;
    const cartValueLimit = 99999;
    const percentageMultiplierForInsurance = 0.02;
    
    ineligibleProductsInCartJSON = ineligibleProductsInCartJSON.concat(packageProtectionProductsInCart);

    for (let i = 0; i < ineligibleProductsInCartJSON.length; i++) {
        totalProductVariantsPrice = totalProductVariantsPrice + ineligibleProductsInCartJSON[i].line_price;
    }

    let cartTotal = parseFloat(cartJSON.total_price - totalProductVariantsPrice);
    if (cartTotal == 0) {
        console.log("Cart is empty.")
        return null;
    }
    if (cartTotal > cartValueLimit) {
        console.log("Cart value is greater than SVP Package Protection threshold.")
        return null;
    }
    let packageProtectionValue = (cartTotal * percentageMultiplierForInsurance);
    packageProtectionValue = Math.trunc(packageProtectionValue) * 0.01;
    let variantToBeAdded = null;
    for (i = 0; i < packageProtectionJSON.variants.length; i++) {
        currentVariant = packageProtectionJSON.variants[i];
        variantPrice = parseFloat(currentVariant.price);
        let packageProtectionDelta = variantPrice - packageProtectionValue;

        if ((0 <= packageProtectionDelta) && (packageProtectionDelta < variantPricingDifference)) {
            variantToBeAdded = currentVariant;
            break;
        }
    }
    return variantToBeAdded;
}

const ineligibleItemsInCart = (cartJSON, ineligibleItemsList) => {
    let ineligibleProductsInCart = [];
    for (i = 0; i < cartJSON.items.length; i++) {
        item = cartJSON.items[i];
        
        if (ineligibleItemsList.includes(item.product_id)) {
            ineligibleProductsInCart.push(item);
        }
    }
    return ineligibleProductsInCart;
}

const isPackageProtectionInCart = (cartJSON, packageProtectionJSON) => {
    let productID = packageProtectionJSON.id;

    let ineligibleProductsInCart = [];
    for (i = 0; i < cartJSON.items.length; i++) {
        item = cartJSON.items[i];
        
        if (item.product_id == productID) {
            ineligibleProductsInCart.push(item);
        }
    }
    return ineligibleProductsInCart;
}

const getCart = async() => {
    let cartJSON = await $.getJSON(`/cart.js`);
    return cartJSON;
}

const getProductData = async(productURL) => {
    let packageProtectionJSON = await $.getJSON(productURL);
    return packageProtectionJSON.product;
}

const orderContainsStorePickupItem = async(cartJSON) => {
    const storePickupHandle = 'store-pick-up';
    const productURL = `/products/${storePickupHandle}.json`
    let storePickupJSON = await getProductData(productURL);
    let storePickupPID = storePickupJSON.id;
    let currentVariant = null;
    let orderContainsStorePickupItem = false;

    for (let i = 0; i < cartJSON.items.length; i++) {
        currentVariant = cartJSON.items[i];
        if (currentVariant.product_id == storePickupPID) {
            orderContainsStorePickupItem = true;
        }
    }

    return orderContainsStorePickupItem;

}

const addCoverage = async(variantId) => {
    await $.ajax({
        type: "POST",
        url: "/cart/add.js",
        data: {
            id: variantId,
            quantity: 1
        },
        dataType: 'json'
    });
}

const removeCoverage = async(variantId) => {
    await $.ajax({
        type: "POST",
        url: "/cart/change.js",
        data: {
            id: variantId,
            quantity: 0
        },
        dataType: 'json'
    });
}

const removeAllVariants = async(packageProtectionProductsInCart) => {
    for (let i = 0; i < packageProtectionProductsInCart.length; i++) {
        await removeCoverage(packageProtectionProductsInCart[i].variant_id);
    }
}

const setPackageProtectionCookie = () => {
    sessionStorage.setItem(`package-protection-block`, "true");
    setPackageProtectionBlockText();
}

const removePackageProtectionCookie = (itemKey, toggleStatus) => {
    productVID = [{"id": "41676670435482"
        },{"id": "41662990647450"
        },{"id": "41676670861466"
        },{"id": "41662990680218"
        },{"id": "41676671975578"
        },{"id": "41662990712986"
        },{"id": "41676672237722"
        },{"id": "41662990745754"
        },{"id": "41676673679514"
        },{"id": "41662990778522"
        },{"id": "41676673974426"
        },{"id": "41673830695066"
        },{"id": "41677321273498"
        },{"id": "41677321371802"
        },{"id": "41677321437338"
        },{"id": "41677321502874"
        },{"id": "41677321601178"
        },{"id": "41677321633946"
        },{"id": "41677321666714"
        },{"id": "41677321699482"
        },{"id": "41677321732250"
        },{"id": "41677321765018"
        },{"id": "41677321797786"
        },{"id": "41677321830554"
        },{"id": "41677321863322"
        },{"id": "41677321896090"
        },{"id": "41677321928858"
        },{"id": "41677321961626"
        },{"id": "41677321994394"
        },{"id": "41677322027162"
        },{"id": "41677322059930"
        },{"id": "41677322092698"
        },{"id": "41677322125466"
        },{"id": "41677322158234"
        },{"id": "41677322191002"
        },{"id": "41677322256538"
        },{"id": "41677322289306"
        },{"id": "41677322322074"
        },{"id": "41677322354842"
        },{"id": "41677322387610"
        }]
    if(typeof(itemKey) === "string") {
        for(let i = 0; i < productVID.length; i++){
            if(itemKey.includes(productVID[i].id)){
                toggleStatus = true;
                break;
            }
        }
    }
    if (toggleStatus) {
        sessionStorage.setItem(`package-protection-block`, "false");
        setPackageProtectionBlockText();
    }
}

const setPackageProtectionBlockText = () => {

    let el = document.getElementById(`package-protection-block`);
    if (el !== null) {
        let packageProtectionAcceptedCookie = sessionStorage.getItem(`package-protection-block`);
        if (packageProtectionAcceptedCookie !== null) {
            packageProtectionAcceptedCookie = (packageProtectionAcceptedCookie.toLowerCase() === 'true');
            if (packageProtectionAcceptedCookie) {
                el.textContent = "Remove SVP Package Protection";
            } else {
                el.textContent = "Add SVP Package Protection";
            }
        }
        else {
            el.textContent = "SVP Package Protection";
        }
    }


}